import { render } from "./TabSelector.vue?vue&type=template&id=6a964671&scoped=true"
import script from "./TabSelector.vue?vue&type=script&lang=js"
export * from "./TabSelector.vue?vue&type=script&lang=js"

import "./TabSelector.vue?vue&type=style&index=0&id=6a964671&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a964671"]])

export default __exports__